<template>
    <div class="c-o-login-form" @keyup.enter="logIn()">
        <div class="c-o-login-form__inner">
            <div
                class="c-o-login-form__message"
                v-if="errorMessages.length > 0"
            >
                <message type="error">
                    <div class="o-wysiwyg">
                        <ul>
                            <li
                                v-for="(message, index) in errorMessages"
                                :key="`message-${index}`"
                            >
                                {{ message }}
                            </li>
                        </ul>
                    </div>
                </message>
            </div>
            <h1>Logga in</h1>
            <p>
                Som <b>kund</b> kan du redigera dina förfrågningar,
                kontaktuppgifter och sätta omdöme när du har loggat in.
            </p>
            <p>
                Är du <b>hantverkare</b> kan du besvara förfrågningar, ändra
                sökprofil, redigera din profilsida m.m.
            </p>
            <input-text
                :icon="'mail'"
                :id="666"
                :name="'username'"
                :label="'E-post'"
                :placeholder="'Ex. kalle@brabyggare.se'"
                class="c-o-login-form__username"
                :class="{
                    'c-o-login-form__inner--invalid-animation': errors.username
                }"
                v-model="username"
                :invalid="errors.username"
            >
            </input-text>
            <input-password
                :icon="'key'"
                :id="677"
                :name="'current-password'"
                :label="'Lösenord'"
                :placeholder="'Ange ditt lösenord'"
                class="c-o-login-form__password"
                :class="{
                    'c-o-login-form__inner--invalid-animation': errors.password
                }"
                v-model="password"
                :invalid="errors.password"
            >
            </input-password>
            <success-button
                class="c-a-button-theme-primary c-o-login-form__submit"
                :currentState="state"
                @buttonClicked="logIn"
                :customStates="states"
            >
            </success-button>
            <router-link
                to="/logga-in/glomt-losenordet"
                class="c-o-login-form__link"
                >Har du glömt ditt lösenord?</router-link
            >
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    GET_ERROR,
    GET_USER,
    IS_LOADING,
    LOG_IN
} from "../../../store/store-models/authentication-model";

import { timeout } from "../../../helpers";
import {
    hasErrors,
    isEmailValid,
    setErrors
} from "../../../helpers/error-validation";

import Icon from "../../components/atoms/AtomIcon.vue";
import SuccessButton from "../../components/atoms/AtomSuccessButton.vue";
import InputPassword from "../../components/atoms/form/AtomInputPassword.vue";
import InputText from "../../components/atoms/form/AtomInputText.vue";
import Message from "../../components/molecules/MoleculeMessage.vue";

export default {
    components: {
        InputText,
        InputPassword,
        SuccessButton,
        Icon,
        Message
    },
    data() {
        return {
            username: "",
            password: "",
            errorMessages: [],
            errors: {
                username: false,
                password: false
            },
            states: {
                default: {
                    label: "Logga in"
                },
                processing: {
                    label: "Loggar in"
                },
                success: {
                    label: "Inloggad!"
                },
                error: {
                    label: "Fel!"
                }
            },
            state: "default"
        };
    },
    computed: {
        ...mapGetters({
            getError: GET_ERROR,
            user: GET_USER,
            isLoading: IS_LOADING
        })
    },
    methods: {
        async logIn() {
            this.errorMessages = [];
            setErrors(this.errors, ["username", "password"], false);

            if (!this.username || !this.password) {
                ["username", "password"].forEach(async model => {
                    const value = !this[model] ? true : false;
                    setErrors(this.errors, [model], value);
                });

                this.errorMessages.push("Fyll i alla fält");
            }

            if (this.username && !isEmailValid(this.username)) {
                this.errorMessages.push("Fyll i en korrekt mailadress");
                setErrors(this.errors, ["username"], true);
            }

            if (hasErrors(this.errors, ["username", "password"])) {
                this.state = "error";
                return;
            }

            const userInfo = {
                username: this.username,
                password: this.password,
                grant_type: "password"
            };

            this.state = "processing";

            try {
                await this.$store.dispatch(LOG_IN, userInfo);
                this.state = "success";
                this.$router.push("/mina-sidor");
            } catch (error) {
                this.errorMessages.push(this.getError);
                this.state = "error";
            }

            await timeout();
            this.state = "default";
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismLoginForm.vue